export const Recall = {
    SET_RECALL_REQUEST_ENTRIES: "recall.request.entries.set",
    SET_RECALL_REQUEST_COMMENT: "recall.request.comment.set",
    ATTACH_MARKET_DATA: "recall.attach_market_data",
    DELETE_RECALL_REQUEST_ENTRY: "recall.request.entry.delete",
    UPDATE_RECALL_REQUEST_ENTRY: "recall.request.entry.update",
    SET_BORROWER_RECALL_ENTRIES: "recall.borrower.entries.set",
    SET_LENDER_RECALL_ENTRIES: "recall.lender.entries.set",
    SET_RECALLS_LIST_HAS_UPDATE: "recall.list.has_update",
};
